<template>
    <div class="list-container">
        <v-row>
            <v-col cols="12" class="list-title">
                {{ activeCoaches }} {{ $t('admin.active_coaches') }}
            </v-col>
            <v-col cols="7">
                <kimsa-text-field
                    @change="search = $event"
                    :value="search"
                    :placeholder="$t('admin.search_coach')"
                    color="accent" dense outlined
                    prepend-inner-icon="$search"
                />
            </v-col>
            <v-col cols="5">
                <v-btn class="b-primary" depressed @click="showInviteDialog">
                    {{ $t('admin.add_coach') }}
                </v-btn>
            </v-col>
            <v-col cols="12">
                <kimsa-data-table
                    :headers="headers"
                    :items="coaches"
                    :loading="loading"
                    :outer-search="search"
                    @click:profile="onClickProfile"
                />
            </v-col>
        </v-row>

        <invite-coach-dialog ref="invite"/>
    </div>
</template>

<script>
import KimsaDataTable from "@/components/common/KimsaDataTable";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import InviteCoachDialog from "@/components/company/InviteCoachDialog";
import {db} from "@/utils/Firebase";

export default {
    name: "ListCoaches",
    components: {InviteCoachDialog, KimsaTextField, KimsaDataTable},
    data(vm) {
        return {
            loading: false,
            search: '',
            headers: [
                {text: '', value: 'avatar', type: 'img'},
                {text: vm.$t('common.name'), value: 'name'},
                {text: vm.$t('common.description'), value: 'description'},
                {text: vm.$t('common.students'), value: 'students'},
                {text: vm.$t('common.groups'), value: 'groups'},
                {text: vm.$t('common.status'), value: 'status', type: 'status'},
                {text: '', value: 'actions', buttons: [{text: '', value: 'profile', icon: '$right_arrow'}]}
            ],
            coaches: [],
        }
    },
    computed: {
        activeCoaches(vm = this) {
            return vm.account?.activeCoaches || 0
        }
    },
    async mounted() {
        const vm = this
        await vm.loadCoaches()
    },
    methods: {
        async loadCoaches() {
            const vm = this
            vm.loading = true

            let coachesRef = await db.collection('users')
                .where('coachSubscription.companyId', '==', vm.currentUser.uid).get()
            // console.log('coachesRef', coachesRef)

            let coaches = []

            for (let coach of coachesRef.docs) {
                let coachData = coach.data()
                let description = coachData?.description ? coachData?.description.substr(0, 50) + '...' : 'n/d'

                coaches.push({
                    id: coach.id,
                    avatar: coachData.avatar || vm.imgPlaceholder,
                    name: coachData.name || 'n/d',
                    description: description,
                    students: coachData.activeStudents || 0,
                    groups: coachData.groupsQuantity || 0,
                    status: coachData.coachSubscription?.paused === true
                })
            }

            vm.coaches = coaches

            vm.loading = false
        },
        showInviteDialog() {
            const vm = this
            vm.$refs.invite.show()
        },
        onClickProfile(id) {
            const vm = this
            vm.$router.push({name: 'company.coaches.profile', params: {id: id}})
        }
    }
}
</script>

<style scoped>

.list-container {
    background: #FFFFFF;
    box-shadow: 0px 4px 8px rgba(217, 217, 217, 0.19);
    border-radius: 4px;
    padding: 24px;
}

.list-title {
    font-weight: 700;
    font-size: 24px;
    line-height: 29px;
    color: #333333;
}

</style>